import React from "react";
import { Row, Col } from "reactstrap";

import UsersGrowthChart from "./UsersGrowthChart";
import UsersSummaryCard from "./UsersSummaryCard";
import CriticalAlertsCard from "./CriticalAlertsCard";
import AutomaticInsightsCard from "./AutomaticInsightsCard";

const DashboardManagement = ({ province, city }) => {

    return (

        <Row className="g-4">

            <Col xl="7">

                <Row className="g-4">

                    <Col md="7" className="d-flex">
                        <UsersGrowthChart province={province} city={city} />
                    </Col>

                    <Col md="5" className="d-flex">
                        <UsersSummaryCard province={province} city={city} />
                    </Col>

                </Row>

            </Col>

            <Col xl="5">

                <Row className="g-4">

                    <Col md="6" className="d-flex">
                        <CriticalAlertsCard />
                    </Col>

                    <Col md="6" className="d-flex">
                        <AutomaticInsightsCard />
                    </Col>

                </Row>

            </Col>

        </Row>

    );

};

export default DashboardManagement;